var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"multiple":_vm.multiple,"placeholder":"请选择计量单位","idKey":"UnitId","labelKey":"UnitName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v),"change":function($event){return _vm.$emit('change')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }